module.exports = __webpack_public_path__ + "img/user.5bf55cf5.svg";